import { API_BASE_URL } from "../../config";

export const AUTH_SCHEME = "Token";

const jsonHeaders = {
  "Content-Type": "application/json",
  Accept: "application/json",
};

const parseErrorResponse = async (response) => {
  const data = await response.json().catch(() => ({}));
  return (
    data.non_field_errors?.[0] ||
    data.detail ||
    data.message ||
    data.error ||
    `Request failed with status ${response.status}`
  );
};

export const performLogout = async (token) => {
  if (!token) return;
  try {
    await fetch(`${API_BASE_URL}/api/logout/`, {
      method: "POST",
      headers: { Authorization: `${AUTH_SCHEME} ${token}` },
    });
  } catch (error) {
    console.error("Error during logout request:", error);
  }
};

export const loginWithCredentials = async ({ email, password }) => {
  const normalizedEmail = email?.trim().toLowerCase() || "";
  const displayEmail = email?.trim() || "";

  const response = await fetch(`${API_BASE_URL}/api/login/`, {
    method: "POST",
    headers: jsonHeaders,
    body: JSON.stringify({
      username: normalizedEmail,
      email: normalizedEmail,
      password,
    }),
  });

  if (!response.ok) {
    throw new Error(await parseErrorResponse(response));
  }

  const data = await response.json();
  const token = data.token || data.access;
  if (!token) {
    throw new Error("Authentication response missing token.");
  }

  return {
    token,
    username: displayEmail,
  };
};

export const loginWithGoogleCredential = async (credential) => {
  const response = await fetch(`${API_BASE_URL}/api/login/google/`, {
    method: "POST",
    headers: jsonHeaders,
    body: JSON.stringify({ credential }),
  });

  if (!response.ok) {
    throw new Error(await parseErrorResponse(response));
  }

  const data = await response.json();
  const token = data.token;
  if (!token) {
    throw new Error("Server response missing token.");
  }

  const username =
    data.username?.trim() ||
    data.email?.trim() ||
    data.display_name?.trim() ||
    "Google user";

  return {
    token,
    username,
  };
};

export const fetchUserStatus = async (token) => {
  const response = await fetch(`${API_BASE_URL}/api/user-status/`, {
    headers: {
      Authorization: `${AUTH_SCHEME} ${token}`,
      Accept: "application/json",
    },
  });

  if (!response.ok) {
    const message = await parseErrorResponse(response);
    const error = new Error(message);
    error.status = response.status;
    throw error;
  }

  return response.json();
};
